import PropTypes from "prop-types";
import * as React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { canonicalPath } from "../../shared/routes/index.js";

CanonicalRedirect.propTypes = { children: PropTypes.node.isRequired };

export default function CanonicalRedirect({ children }) {
  const { pathname, search, hash } = useLocation();
  const target = canonicalPath({ pathname, search });

  return target ? <Redirect to={`${target}${hash}`} /> : children;
}
